// Static UI labels for the public job pages (listing + detail).
//
// Locale codes match `job_translations.locale` in the V1 DB, so the same code
// that picks a job's translated title also picks its labels.
//
// To add a language: add one block below (e.g. `ms: {...}`) and one entry to
// LANGUAGES. Nothing else changes — components read through t().
// Any key missing from a language falls back to English.

const LABELS = {
  en: {
    // listing page
    listing_heading: "Part Time Jobs In Singapore",
    keywords: "Keywords",
    search: "Search",
    clear_filter: "Clear Filter",
    company: "Company",
    category: "Category",
    ph_job_title: "e.g. job title",
    ph_company: "Enter to search Company",
    ph_category: "Enter to search Category",
    people_also_searched: "People also searched:",
    rows_per_page: "Rows per page",
    tags: "Tags",
    ph_tag: "Enter to search tag",
    no_result: "No Result.",
    // detail page
    salary: "Salary",
    per_hour_rate: "Per Hour Rate",
    per_hr: "/HR",
    suggested_jobs: "Suggested Jobs",
    suggested_by_category: "Suggested Jobs By Category",
    suggested_by_company: "Suggested Jobs By Company",
    job_summary: "Job Summary",
    job_id: "Job ID",
    job_date: "Job Date",
    job_timing: "Job Timing",
    job_category: "Job Category",
    job_type: "Job Type",
    location: "Location",
    part_time: "Part Time",
    apply_now: "Apply Now",
    job_scope: "Job Scope",
    job_requirements: "Job Requirements",
    popular_searches: "Popular searches",
    browse_by_area: "Browse by area",
    employers_hiring: "Employers hiring now",
    show_more: "+{n} more",
    show_less: "Show less",
    see_all_employer_jobs: "See all jobs from this employer",
    shift_dates: "Shift Dates For This Job",
    shift_dates_hint: "This job runs on several dates. Pick the one you want:",
    viewing_this_date: "Viewing this date",
    job_link: "Job Link",
    about_employer: "About the Employer",
    interesting: "Interesting?",
    share_it: "Share It!",
    hrs: "Hrs",
    unpaid_break: "hrs unpaid break",
    position_filled: "This position has been filled.",
    browse_similar: "Browse similar jobs below.",
    no_company_found: "No Company Found.",
    no_category_found: "No Category Found.",
    on_demand: "On-Demand",
    no_record_found: "No Record Found",
    ph_search_category: "Search Category",
    ph_search_company: "Search Company",
    copied_clipboard: "Copied to clipboard!",
    app_desc: "Discover part time jobs and full-time opportunities at your fingertips. Stay connected and manage your profile easily with our app.",
  },
  zh: {
    // listing page
    listing_heading: "新加坡兼职工作",
    keywords: "关键词",
    search: "搜索",
    clear_filter: "清除筛选",
    company: "公司",
    category: "类别",
    ph_job_title: "例如：工作名称",
    ph_company: "输入以搜索公司",
    ph_category: "输入以搜索类别",
    people_also_searched: "其他人也在搜索：",
    rows_per_page: "每页显示",
    tags: "标签",
    ph_tag: "输入以搜索标签",
    no_result: "没有结果。",
    // detail page
    salary: "薪资",
    per_hour_rate: "时薪",
    per_hr: "/小时",
    suggested_jobs: "推荐工作",
    suggested_by_category: "同类推荐工作",
    suggested_by_company: "该公司的其他工作",
    job_summary: "工作摘要",
    job_id: "工作编号",
    job_date: "工作日期",
    job_timing: "工作时间",
    job_category: "工作类别",
    job_type: "工作类型",
    location: "地点",
    part_time: "兼职",
    apply_now: "立即申请",
    job_scope: "工作范围",
    job_requirements: "工作要求",
    popular_searches: "热门搜索",
    browse_by_area: "按地区浏览",
    employers_hiring: "正在招聘的雇主",
    show_more: "+{n} 更多",
    show_less: "收起",
    see_all_employer_jobs: "查看该雇主的所有工作",
    shift_dates: "此工作的可选日期",
    shift_dates_hint: "此工作有多个日期，请选择您要的日期：",
    viewing_this_date: "当前查看日期",
    job_link: "工作链接",
    about_employer: "关于雇主",
    interesting: "觉得不错？",
    share_it: "分享给朋友！",
    hrs: "小时",
    unpaid_break: "小时无薪休息",
    position_filled: "此职位已招满。",
    browse_similar: "请浏览下方的类似工作。",
    no_company_found: "未找到公司。",
    no_category_found: "未找到类别。",
    on_demand: "即时工作",
    no_record_found: "没有找到记录",
    ph_search_category: "搜索类别",
    ph_search_company: "搜索公司",
    copied_clipboard: "已复制到剪贴板！",
    app_desc: "随时随地发现兼职与全职工作机会。通过我们的应用保持联系并轻松管理您的个人资料。",
  },
  th: {
    // listing page
    listing_heading: "งานพาร์ทไทม์",
    keywords: "คำค้นหา",
    search: "ค้นหา",
    clear_filter: "ล้างตัวกรอง",
    company: "บริษัท",
    category: "หมวดหมู่",
    ph_job_title: "เช่น ชื่อตำแหน่งงาน",
    ph_company: "พิมพ์เพื่อค้นหาบริษัท",
    ph_category: "พิมพ์เพื่อค้นหาหมวดหมู่",
    people_also_searched: "คนอื่นค้นหา:",
    rows_per_page: "จำนวนแถวต่อหน้า",
    tags: "แท็ก",
    ph_tag: "พิมพ์เพื่อค้นหาแท็ก",
    no_result: "ไม่พบผลลัพธ์",
    // detail page
    salary: "ค่าตอบแทน",
    per_hour_rate: "อัตราต่อชั่วโมง",
    per_hr: "/ชม.",
    suggested_jobs: "งานแนะนำ",
    suggested_by_category: "งานแนะนำตามหมวดหมู่",
    suggested_by_company: "งานอื่นจากบริษัทนี้",
    job_summary: "สรุปรายละเอียดงาน",
    job_id: "รหัสงาน",
    job_date: "วันที่ทำงาน",
    job_timing: "เวลาทำงาน",
    job_category: "หมวดหมู่งาน",
    job_type: "ประเภทงาน",
    location: "สถานที่",
    part_time: "พาร์ทไทม์",
    apply_now: "สมัครเลย",
    job_scope: "ขอบเขตงาน",
    job_requirements: "คุณสมบัติที่ต้องการ",
    popular_searches: "การค้นหายอดนิยม",
    browse_by_area: "เลือกตามพื้นที่",
    employers_hiring: "ผู้ว่าจ้างที่กำลังรับสมัคร",
    show_more: "+{n} เพิ่มเติม",
    show_less: "แสดงน้อยลง",
    see_all_employer_jobs: "ดูงานทั้งหมดจากผู้ว่าจ้างนี้",
    shift_dates: "วันที่ทำงานของงานนี้",
    shift_dates_hint: "งานนี้มีหลายวัน เลือกวันที่คุณต้องการ:",
    viewing_this_date: "กำลังดูวันนี้",
    job_link: "ลิงก์งาน",
    about_employer: "เกี่ยวกับผู้ว่าจ้าง",
    interesting: "สนใจงานนี้?",
    share_it: "แชร์เลย!",
    hrs: "ชม.",
    unpaid_break: "ชม. พักโดยไม่ได้รับค่าจ้าง",
    position_filled: "ตำแหน่งนี้มีผู้ได้รับงานแล้ว",
    browse_similar: "ดูงานที่คล้ายกันด้านล่าง",
    no_company_found: "ไม่พบบริษัท",
    no_category_found: "ไม่พบหมวดหมู่",
    on_demand: "งานด่วน",
    no_record_found: "ไม่พบข้อมูล",
    ph_search_category: "ค้นหาหมวดหมู่",
    ph_search_company: "ค้นหาบริษัท",
    copied_clipboard: "คัดลอกแล้ว!",
    app_desc: "ค้นหางานพาร์ทไทม์และงานประจำได้ในปลายนิ้ว เชื่อมต่อและจัดการโปรไฟล์ของคุณได้ง่าย ๆ ผ่านแอปของเรา",
  },
};

// Order controls the toggle button cycle; the first entry is the default.
// The per-country lists live on the country profile (config/countries.js —
// jobLabelLanguages): SG keeps English <-> Chinese, TH gets Thai <-> English.
import { profileFor } from "../config/countries";

// Accepts a country code from the gate ($country). A bare boolean is still
// honoured (legacy isTH callers): true → TH, false → SG.
function countryOf(arg) {
  if (arg === true) return "TH";
  if (typeof arg === "string" && arg) return arg;
  return "SG";
}

// The language list for this deployment.
export function languagesFor(country) {
  return profileFor(countryOf(country)).jobLabelLanguages;
}

// The locale a page should open in.
export function defaultLanguage(country) {
  return languagesFor(country)[0].code;
}

// Translate a label key for the given locale, falling back to English.
export function t(lang, key) {
  const dict = LABELS[lang] || LABELS.en;
  if (dict[key] !== undefined) return dict[key];
  return LABELS.en[key] !== undefined ? LABELS.en[key] : key;
}

// The language to switch to when the toggle is pressed, and its button label.
export function nextLanguage(current, country) {
  const list = languagesFor(country);
  const i = list.findIndex((l) => l.code === current);
  return list[(i + 1) % list.length];
}

export default LABELS;
